module.exports = __webpack_public_path__ + "img/mile3-m@1.d393e3e4.jpg";